import React from "react";
import { STAGES, getStage } from "../data/stages";
import { useApp } from "../context/AppContext";

function StageSelect({ job, size = "sm" }) {
  const { moveJob, toast } = useApp();
  const stage = getStage(job.stage);

  const handleChange = async (e) => {
    const next = e.target.value;
    if (await moveJob(job.id, next)) toast(`Moved to ${getStage(next).label}`);
  };

  return (
    <select
      className={`form-select form-select-${size} stage-select`}
      style={{ "--stage-color": stage.color }}
      value={job.stage}
      onChange={handleChange}
      onClick={(e) => e.stopPropagation()}
      aria-label="Change stage"
    >
      {STAGES.map((s) => (
        <option key={s.id} value={s.id}>
          {s.label}
        </option>
      ))}
    </select>
  );
}

export default StageSelect;
